import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'image-view-product',
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './image-view-product.component.html',
  styleUrl: './image-view-product.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageViewProduct implements OnChanges {

  @Input() imageUrl = '';
  @Input() alt = 'Imagen del producto';
  @Input() loading = false;
  private readonly defaultImage = 'assets/imagen_default.png';


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageUrl']) {
      this.imageUrl = changes['imageUrl'].currentValue;
    }
  }

  onImageError(event: any): void {
    event.target.src = this.defaultImage;
  }

}
